import {
  type FC, useCallback, useState,
} from 'react';
import { type RouteProps } from 'react-router-dom';
import { getIsPageRefreshed } from '~/_shared/utils/url/url.helpers';
import { useUserDataSelector } from '~/store/userData/userData.selectors';
import { LoginPageComponent } from './loginPage.component';
import { useNavigateAfterLogin } from './useNavigateAfterLogin';

type LoginPageContainer = RouteProps;

export const LoginPageContainer: FC<LoginPageContainer> = (props) => {
  const userData = useUserDataSelector();
  const isPageRefreshed = getIsPageRefreshed();

  const [loginFormSubmitted, setLoginFormSubmitted] = useState<boolean>(false);

  const onLoginFormSubmit = useCallback(() => {
    setLoginFormSubmitted(true);
  }, []);

  useNavigateAfterLogin();

  return (
    <LoginPageComponent
      {...props}
      isLoading={isPageRefreshed && userData.isLoading && !loginFormSubmitted}
      onLoginFormSubmit={onLoginFormSubmit}
    />
  );
};
